module.exports = __webpack_public_path__ + "img/M_Read_more_compare_male.aa7378f6.svg";